
// const wait = (ms) => {}
export const useInitSessionAndUserData = () => {
  const init = async (_route?: any) => {
    // console.log('2-------------------------------')
    
    // console.log('calling init with route:', _route)
    // console.log('pinia is:', useNuxtApp().$pinia)
    const visitorSession = useVisitorSession()
    const user = useUser()
    const route = _route || useRoute()
    
    try {
      // console.log(11)
      await visitorSession.getSession()
      // console.log(22222222, 'visitorSession is', visitorSession.$state)
      
      // console.log('visitorSession.user_id:', visitorSession.user_id, 'logged in:', visitorSession.loggedIn)
      let userIdToFetch = visitorSession.user_id
      // console.log('111 --> userIdToFetch:', userIdToFetch, typeof userIdToFetch, 'route.params.userId is', route.params.userId)
      if (!visitorSession.loggedIn) {
        // console.log('session user is not logged in. END.')
        return
      }
      // console.log(33)
      
      if (visitorSession.realAdmin) {
        // console.log('---------------------------')
        // console.log('route.params.userId is number?', /\d+/.test(route.params.userId))
        // console.log('route.query.asUser is', route.query.asUser)

        if (route.query.asUser) {
          // console.log('route.query.asUser is', route.query.asUser)
          userIdToFetch = Number(route.query.asUser)
          // console.log('set userIdToFetch to Number asUser:', route.query.asUser, '->', userIdToFetch)
        } else if (route.params.userId) {
          if (/\d+/.test(route.params.userId)) {
            userIdToFetch = Number(route.params.userId)
            // console.log('set userIdToFetch to Number(route.params.userId):', route.params.userId, '->', userIdToFetch)
          } else {
            // console.log('route.params.userId is NaN/email', route.params.userId)
            userIdToFetch = route.params.userId
            // console.log('set userIdToFetch to (as String) route.params.userId:', route.params.userId, '->', userIdToFetch)
          }
        }
      }
      // console.log('!!!!!!!userIdToFetch:', userIdToFetch, typeof userIdToFetch, 'visitorSession.user_id:', visitorSession.user_id, typeof visitorSession.user_id, 'userIdToFetch is visitorSession.user_id ?', userIdToFetch === visitorSession.user_id)
      // console.log('going to call user.get')
      // await wait(1000)
      // console.log('route.params.userId is', route.params.userId, 'visitorSession.id:', visitorSession.id, 'userIdToFetch:', userIdToFetch, 'visitorSession.id === userIdToFetch:', visitorSession.id === userIdToFetch)
      if (visitorSession.id === userIdToFetch) {
        // console.log('userIdToFetch === visitorSession.user_id, using session.state as user data')
        user.setUserData(visitorSession.$state as any)
      } else {
        // console.log('~~~~userIdToFetch:', userIdToFetch, 'visitorSession.id:', visitorSession.id, 'visitorSession.id === userIdToFetch:', visitorSession.id === userIdToFetch)
        // const data = await user.get({ id: userIdToFetch })
        const data = await useAPI().get('/users/' + userIdToFetch, { key: `user-${userIdToFetch}` })
        // if (data) {
        // }
        user.setUserData(data)
      }
      // console.log(55)
    } catch (error: any) {
      console.log(66, 'error-->', error)
      useFullscreenLoading().close()
      throw error
    }
    // console.log(77)
    
    // if ($route.params.userId && $route.params.userId !== String(user.id)) {
    //   console.log('route.params.userId:->>', $route.params.userId)
    //   $route.params.userId = String(user.id)
    // }
    return {
      session: visitorSession,
      user,
    }
  }
  return {
    init
  }
}
